<template>
  <v-form
    :disabled="form.processing"
    @submit.prevent="submit"
  >
    <v-card>
      <v-card-text>
        <p>
          {{ $t('Create a new FAQ collection by using the guide below. Give your FAQ collection a name and set the default language. Once created, you can add content like categories and questions to it.') }}
        </p>  

        <p v-if="existingFaqs">
          {{ $t('Want to add something to one of your existing FAQs? Switch tab to TEAM FAQS and click on the FAQ you want to manage.') }}
        </p>        
      </v-card-text>

      <v-card-text>
        <v-text-field
          v-model="form.name"
          :loading="form.processing"
          :error-messages="form.errors.name"
          :label="$t('Enter a name for your FAQ')"
          :placeholder="placeholder"
          outlined
          autofocus
        />

        <!-- <v-textarea
            v-model="form.description"
            :loading="form.processing"
            :error-messages="form.errors.description"
            :label="$t('Enter a short description')"
            :rows="3"
            outlined
          /> -->

        <v-autocomplete
          v-model="form.default_language"
          :loading="form.processing"
          :error-messages="form.errors.default_language"
          :items="availableLanguages.map(obj => ({ text: obj.name, value: obj.code }))"
          :label="$t('Select the default language for this FAQ')"
          outlined
          hide-details="auto"
        />

        <open-ai-expansion-panel>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-switch
                v-model="form.open_ai.enabled"
                class="mt-0 mb-4"
                :label="$t('Generate example questions and answers using OpenAI')"
                hide-details
              />
            </v-col>
            <v-col
              v-if="form.open_ai.enabled"
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.open_ai.category"
                :loading="form.processing"
                :error-messages="form.errors['open_ai.category']"
                :label="$t(`Describe your business or website`)"
                :placeholder="$t('E.g. online store for kids toys')"
                :maxlength="50"
                :counter="true"
                hide-details="auto"
                outlined
              />
            </v-col>
          </v-row>

          <v-fade-transition>
            <v-alert
              v-if="loadingChatGpt"
              class="mt-4"
              type="info"
            >
              {{ $t('Generating questions and answers, this may take a little while') }}
            </v-alert>
          </v-fade-transition>
        </open-ai-expansion-panel>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          type="submit"
          color="primary"
          :loading="form.processing"
          :disabled="form.processing"
        >
          {{ $t('Create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import OpenAiExpansionPanel from '@/components/shared/OpenAiExpansionPanel';

export default {
  components: {
    OpenAiExpansionPanel
  },

  props: {
    availableLanguages: {
      type: Array,
      required: true
    },
    numFaqs: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      categoryName: '',
      loadingChatGpt: false,
      existingFaqs: this.numFaqs,

      form: this.$inertia.form({
        name: '',
        description: '',
        default_language: this.$page.props.app_locales.current.code || 'en',
        open_ai: {
          enabled: false,
          category: ''
        }
      })
    }
  },

  computed: {
    placeholder() {
      return this.$t(`"FAQ for my website" for example`);
    }
  },

  methods: {
    handleUpdateCategories(categories) {
      this.form.categories = categories;
    },

    submit() {
      let timeout;

      this.form.post(this.route('faq.store'), {
        onStart: () => {
          timeout = setTimeout(() => {
            if (this.form.open_ai.enabled && this.form.processing) {
              this.loadingChatGpt = true;
            }
          }, 5000);
        },
        onCancel: () => {
          clearTimeout(timeout);
          this.loadingChatGpt = false;
        },
        onFinish: () => {
          clearTimeout(timeout);
          this.loadingChatGpt = false;
        }
      });
    }
  }
}
</script>